import React from "react";
import { useLocation } from "react-router-dom";
import PropTypes from 'prop-types';


export default function ScrollToTop () {
    const { pathname } = useLocation();

    const MoveTop = () => {
        window.scrollTo(0, 0);
    };

    React.useEffect(() => {
        MoveTop();
    }, [pathname]);

    return null;
};


export function HandleToTop (props) {
    const { scrollHeight = 100 } = props;
    const [BtnStatus, setBtnStatus] = React.useState(false); // 버튼 상태


    const handleFollow = () => {
        setBtnStatus(window.pageYOffset > scrollHeight);
    };

    const handleTop = () => {  // 클릭하면 스크롤이 위로 올라가는 함수
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setBtnStatus(false);
    };
    
    React.useEffect(() => {
        const watch = () => {
            window.addEventListener('scroll', handleFollow)
        }
        watch();
        return () => {
            window.removeEventListener('scroll', handleFollow)
        }
    });

    return (
        <div className="wrap">
          <button 
            className={BtnStatus ? "topBtn active" : "topBtn"} // 버튼 노출 여부
            onClick={handleTop}  // 버튼 클릭시 함수 호출
          >
            TOP
          </button>
        </div>
    );
};

HandleToTop.propTypes = {
    scrollHeight: PropTypes.number,
};